import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { Return } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import EmployeeAccessSearchField from './EmployeeAccessSearchField'
import IdClockSharedDeviceUrl from './IdClockSharedDeviceUrl'

interface ToggleProps {
  policyForm: FormikProps<UpdateAttendanceSettingMutationVariables>
  updatePolicy: (value?: { successFlash: boolean }) => Promise<Return<void>>
  attendanceSetting: AttendanceSetting
}

const IdClockSharedDeviceToggle = ({
  updatePolicy,
  policyForm,
  attendanceSetting,
}: ToggleProps) => {
  const idClockSharedDeviceField = policyForm.values.idClockSharedDevice

  const onChange = (status: boolean) => {
    policyForm.setFieldValue('idClockSharedDevice', status)
    if (status) {
      policyForm.setValues({
        ...policyForm.values,
        idClockSharedDevice: status,
        faceRecognition: false,
      })
    }
    updatePolicy()
  }

  return (
    <CollapsableCard
      open={!!idClockSharedDeviceField}
      Card={
        <Box
          gap="s8"
          extra={{
            'data-intercom-target': 'attendance-policy-details-toggles-id-clock-shared-device',
          }}
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.form.toggle.id_clock_shared_device.title')}
            </Text.Normal>
            <TogglerCheckbox
              value={!!idClockSharedDeviceField}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal color="grey800" htmlTag="div">
            {i18n.t('time_tracking.settings.form.toggle.id_clock_shared_device.description')}
          </Text.Normal>
        </Box>
      }
      Content={
        <Box gap="s8" padding="s24">
          <EmployeeAccessSearchField policyForm={policyForm} updatePolicy={updatePolicy} />
          <IdClockSharedDeviceUrl
            policyForm={policyForm}
            updatePolicy={updatePolicy}
            attendanceSetting={attendanceSetting}
          />
        </Box>
      }
    />
  )
}

export default observer(IdClockSharedDeviceToggle)
